import { GridColDef } from '@mui/x-data-grid';
import Tooltip from '@mui/material/Tooltip';
import { formatTime } from '@Utils/formatTime';
import { ExtendedGridColDef } from '@Types/ExtendedGridColDef';
import { IPayment } from '@Types/Payment';
import CopyColumn from '@Components/table/CopyColumn';

export const paymentColumns: (GridColDef<IPayment> & ExtendedGridColDef)[] = [

  {
    field: 'subAreaId',
    headerName: 'Subarea ID',
    hideable: false,
    flex: 0.1,
    renderCell: (params) => {
      return <CopyColumn value={params.value} />;
    },
    valueGetter: (params) => `${params.row.subAreaId}`,
  },
  // {
  //   field: 'paymentMethodType',
  //   headerName: 'Payment Method',
  //   hideable: false,
  //   flex: 0.1,
  //   renderCell: (params) => {
  //     const value = params.value;

  //     return <Tooltip title={value}>{value}</Tooltip>;
  //   },
  //   valueGetter: (params) =>
  //     (paymentMethodTypeValues as any)[params.row.paymentMethodType],
  // },
  {
    field: 'timestamp',
    headerName: 'Settled Date',
    hideable: false,
    flex: 0.1,
    renderCell: (params) => {
      const dateStr = params.value;

      return (
        <Tooltip title={dateStr}>
          <span className='table-cell-truncate'>{dateStr}</span>
        </Tooltip>
      );
    },
    valueGetter: (params) => formatTime(params.row.timestamp),
  },
  {
    field: 'startTime',
    headerName: 'Start Date',
    hideable: false,
    flex: 0.1,
    renderCell: (params) => {
      const dateStr = params.value;

      return (
        <Tooltip title={dateStr}>
          <span className='table-cell-truncate'>{dateStr}</span>
        </Tooltip>
      );
    },
    valueGetter: (params) => formatTime(params.row.startTime),
  },
    {
    field: 'exitTime',
    headerName: 'Exit Date',
    hideable: false,
    flex: 0.1,
    renderCell: (params) => {
      const dateStr = params.value;

      return (
        <Tooltip title={dateStr}>
          <span className='table-cell-truncate'>{dateStr}</span>
        </Tooltip>
      );
    },
    valueGetter: (params) => formatTime(params.row.exitTime),
  },
  {
    field: 'registrationNumber',
    headerName: 'VRM/VRN',
    hideable: false,
    flex: 0.1,
    renderCell: (params) => {
      return (
        <Tooltip title={params.value}>
          <span className='table-cell-truncate'>{params.value}</span>
        </Tooltip>
      );
    },
    valueGetter: (params) => params.row.registrationNumber,
  },
  // {
  //   field: 'amount',
  //   headerName: 'Amount',
  //   hideable: false,
  //   flex: 0.1,
  //   renderCell: (params) => {
  //     return (
  //       <Tooltip title={params.value}>
  //         <span className='table-cell-truncate'>{params.value}</span>
  //       </Tooltip>
  //     );
  //   },
  //   valueGetter: (params) => `£${params.row.amount?.toFixed(2)}`,
  // },
  {
    field: 'subareaName',
    headerName: 'Subarea Name',
    hideable: false,
    flex: 0.1,
    renderCell: (params) => {
      return (
        <Tooltip title={params.value}>
          <span className='table-cell-truncate'>{params.value}</span>
        </Tooltip>
      );
    },
    valueGetter: (params) => params.row.subAreaName,
  },
  {
      field: 'appAccessType',
    headerName: 'Access Type',
    hideable: false,
    flex: 0.1,
    renderCell: (params) => {
      return (
        <Tooltip title={params.value}>
          <span className='table-cell-truncate'>{params.value}</span>
        </Tooltip>
      );
    },
    valueGetter: (params) => params.row.appAccessType,
  },
  {
    field: 'convenienceFee',
    headerName: 'Conv Fee',
    hideable: false,
    flex: 0.1,
    renderCell: (params) => {
       const formattedValue = typeof params.value === 'number' 
      ? `£${params.value.toFixed(2)}`
      : '0.00';
      
      return (
        <Tooltip title={params.value}>
          <span
            className='table-cell-truncate'
            style={{ textTransform: 'capitalize' }}
          >
            {formattedValue}
          </span>
        </Tooltip>
      );
    },
    valueGetter: (params) => params.row.convenienceFee ?? 0,
  },
  {
    field: 'reminderFee',
    headerName: 'Remi Fee',
    hideable: false,
    flex: 0.1,
    renderCell: (params) => {
     const formattedValue = typeof params.value === 'number' 
      ? `£${params.value.toFixed(2)}`
      : '0.00';

      return (
        <Tooltip title={formattedValue}>
          <span className='table-cell-truncate'>{formattedValue}</span>
        </Tooltip>
      );
    },
    valueGetter: (params) => params.row.reminderFee ?? 0,
  },
  {
    field: 'sessionPrice',
    headerName: 'SessionPrice',
    hideable: false,
    flex: 0.2,
    renderCell: (params) => {
      const formattedValue = typeof params.value === 'number' 
      ? `£${params.value.toFixed(2)}`
      : '0.00';

      return (
        <Tooltip title={formattedValue}>
          <span className='table-cell-truncate'>{formattedValue}</span>
        </Tooltip>
      );
    },
    valueGetter: (params) => params.row.sessionPrice,
  },
  {
    field: 'tax',
    headerName: ' VAT ',
    hideable: false,
    flex: 0.2,
    renderCell: (params) => {
      const formattedValue = typeof params.value === 'number' 
      ? `£${params.value.toFixed(2)}`
      : '0.00';

      return (
        <Tooltip title={formattedValue}>
          <span className='table-cell-truncate'>{formattedValue}</span>
        </Tooltip>
      );
    },
    valueGetter: (params) => params.row.tax,
  },
   {
    field: 'sessionTotal',
    headerName: 'Session Total',
    hideable: false,
    flex: 0.2,
    renderCell: (params) => {
      const formattedValue = typeof params.value === 'number' 
      ? `£${params.value.toFixed(2)}`
      : '0.00';

      return (
        <Tooltip title={formattedValue}>
          <span className='table-cell-truncate'>{formattedValue}</span>
        </Tooltip>
      );
    },
    valueGetter: (params) => params.row.sessionTotal,
  },
  {
    field: 'status',
    headerName: 'Status',
    hideable: false,
    flex: 0.15,
    renderCell: (params) => {
      return (
        <Tooltip title={params.value}>
          <span
            className='table-cell-truncate'
            style={params.value === 'Refunded' ? { color: '#b71c1c', fontWeight: 600 } : undefined}
          >
            {params.value}
          </span>
        </Tooltip>
      );
    },
    valueGetter: (params) => (params.row.status === 'REFUND' ? 'Refunded' : 'Captured'),
  },
];
